import script from "./CommonWageLaborCostModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonWageLaborCostModal.vue?vue&type=script&setup=true&lang=ts"

import "./CommonWageLaborCostModal.vue?vue&type=style&index=0&id=4d9da17c&lang=scss"

const __exports__ = script;

export default __exports__